var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBgFlagGreen(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "30px",
    height: "22px",
    viewBox: "0 0 30 22",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "42D24D5F-1E42-4D5B-93DA-4DEE98A5B7E4") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Stories-\\u2705",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "05A---Stories-(On-this-day)",
    transform: "translate(-12.000000, -862.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Card",
    transform: "translate(12.000000, 846.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-9",
    transform: "translate(0.000000, 16.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "custom-icon-tag-1",
    transform: "translate(15.000000, 11.000000) scale(-1, 1) rotate(-360.000000) translate(-15.000000, -11.000000) "
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "bg-flag",
    fill: "#006238",
    points: "1.40069504e-13 0 30 0 30 21.4285714 1.40069504e-13 21.4285714 6 10.7142857"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.3261473,10.9575755 C15.2909351,12.0973159 16.1883984,12.9947792 17.3281388,16.959567 C17.3592779,17.0679209 17.4585178,17.1428571 17.5714286,17.1428571 C17.6843393,17.1428571 17.7835793,17.068174 17.8147183,16.959567 C18.9544588,12.9947792 19.8519221,12.0973159 23.8167099,10.9575755 C23.9253169,10.9264364 24,10.8271965 24,10.7142857 C24,10.601375 23.9253169,10.502135 23.8167099,10.4709959 C19.8519221,9.33150868 18.9544588,8.43404538 17.8147183,4.46900439 C17.7835793,4.36065057 17.6843393,4.28571429 17.5714286,4.28571429 C17.4585178,4.28571429 17.3592779,4.36039741 17.3281388,4.46900439 C16.1883984,8.43404538 15.2909351,9.33150868 11.3261473,10.4709959 C11.2175403,10.502135 11.1428571,10.601375 11.1428571,10.7142857 C11.1428571,10.8271965 11.2175403,10.9264364 11.3261473,10.9575755 Z",
    id: "Path",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgFlagGreen);
export default __webpack_public_path__ + "static/media/bg-flag-green.bccde74390185e86ad73a38f6fde8e7a.svg";
export { ForwardRef as ReactComponent };